import PropTypes from "prop-types";
import React from "react";

const CcwButton = ({ children, className, icon, type, variant, ...buttonProps }) => {
  const classes = [
    "ccw-button",
    `ccw-button--${variant}`,
    icon ? "ccw-button--icon" : null,
    className
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} {...buttonProps}>
      {children}
    </button>
  );
};

CcwButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  icon: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  variant: PropTypes.oneOf(["primary", "secondary", "quiet", "warning", "danger"])
};

CcwButton.defaultProps = {
  className: "",
  icon: false,
  type: "button",
  variant: "secondary"
};

export default CcwButton;
